import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Label,
  Row,
  Col,
} from "reactstrap";
import { Formik, Form, Field } from "formik";
import { FormattedMessage } from "react-intl";
import TooltipHelp from "../Help/ToolTipHelp";

export default function AddNewTeacherToClass(props) {
  function validateEmail(value) {
    let error;
    if (!value) {
      error = <FormattedMessage id="EmailRequired" />;
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
      error = <FormattedMessage id="WrongEmailFormat" />;
    }
    return error;
  }

  function validateName(value) {
    let error;
    if (!value) {
      error = <FormattedMessage id="NameRequired" />;
    }
    return error;
  }

  return (
    <Modal size="md" isOpen={props.isOpen} toggle={props.toggle}>
      <ModalHeader toggle={props.toggle}>
        <FormattedMessage id="CreateNewTeacherForClass" />{" "}
      </ModalHeader>
      <Formik
        initialValues={{
          name: "",
          email: "",
          purchaser: false,
          fullAccess: false,
        }}
        onSubmit={(values) => props.onSubmit(values)}
      >
        {({ errors, touched }) => (
          <>
            <Form>
              <ModalBody>
                <Row>
                  <Col lg={12}>
                    <Label className="mt-2" for="name">
                      <FormattedMessage id="Name" />:{" "}
                    </Label>
                  </Col>
                  <Col>
                    <Field
                      name="name"
                      validate={validateName}
                      className="form-control"
                    />
                    {errors.name && touched.name ? (
                      <div className="text-danger input-feedback">
                        {errors.name}
                      </div>
                    ) : null}
                  </Col>
                </Row>
                <Row>
                  <Col lg={12}>
                    <Label className="mt-2" for="email">
                      <FormattedMessage id="Email" />:{" "}
                    </Label>
                  </Col>
                  <Col>
                    <Field
                      name="email"
                      type="email"
                      validate={validateEmail}
                      className="form-control"
                    />
                    {errors.email && touched.email ? (
                      <div className="text-danger input-feedback">
                        {errors.email}
                      </div>
                    ) : null}
                  </Col>
                </Row>

                <div role="group" aria-labelledby="checkbox-group">
                  <Row lg={12} className="mt-2 ms-0">
                    <div className="d-flex align-items-center">
                      <Label className="mt-2 me-2" for="purchaser">
                        <FormattedMessage id="Purchaser" />:
                      </Label>
                      <div style={{ position: "relative" }}>
                        <Field
                          className="mt-2 me-2"
                          type="checkbox"
                          disabled={!props.purchaserTeacher}
                          name="purchaser"
                        />
                        <div className="tooltip-container">
                          <TooltipHelp
                            id="ToolTipPurchaser"
                            toolTipText={
                              <FormattedMessage id="ToolTipPurchaser" />
                            }
                            placement="right"
                          />
                        </div>
                      </div>
                    </div>
                  </Row>
                  <Row lg={12} className="ms-0">
                    <div className="d-flex align-items-center">
                      <Label className="mt-2 me-2" for="fullAccess">
                        <FormattedMessage id="FullTeacherAccess" />:
                      </Label>
                      <div style={{ position: "relative" }}>
                        <div>
                          <Field
                            className="mt-2 me-2"
                            type="checkbox"
                            disabled={!props.fullAccessTeacher}
                            name="fullAccess"
                          />
                          <div className="tooltip-container">
                            <TooltipHelp
                              id="ToolTipFullAccessTeacher"
                              toolTipText={
                                <FormattedMessage id="ToolTipFullAccessTeacher" />
                              }
                              placement="right"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </Row>
                </div>
              </ModalBody>
              <ModalFooter className="pt-1" style={{ display: "block" }}>
                <Button
                  size="sm"
                  outline
                  color="primary"
                  className="float-end mb-2"
                  type="submit"
                >
                  <FormattedMessage id="AddTeacher" />
                </Button>
                <Button
                  size="sm"
                  outline
                  color="secondary"
                  onClick={props.toggle}
                  className="float-end"
                >
                  <FormattedMessage id="Cancel" />
                </Button>
              </ModalFooter>
            </Form>
          </>
        )}
      </Formik>
    </Modal>
  );
}
